import React, { useEffect } from 'react';
import './styles.css';
import { Doughnut } from 'react-chartjs-2';
import i18n from '../../../translate/i18n';

interface TypeProps {
  title: string,
  processosTotal: number,
  processosRegulares: number,
  processosIrregulares: number,
}

export default function WidgetChartprocess({ title, processosTotal, processosRegulares, processosIrregulares, }: TypeProps) {


  const data1 = {
    datasets: [
      {
        data: [processosTotal],
        backgroundColor: [
          'rgba(255, 99, 132)'
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)'
        ],
        borderWidth: 1,
      },
    ],
  };
  const data2 = {
    datasets: [
      {
        data: [processosTotal],
        backgroundColor: [
          'rgba(54, 162, 235)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };
  const data3 = {
    datasets: [
      {
        data: [processosTotal],
        backgroundColor: [
          'rgba(255, 206, 86)'
        ],
        borderColor: [
          'rgba(255, 206, 86, 1)'
        ],
        borderWidth: 1,
      },
    ],
  };
  const data4 = {
    datasets: [
      {
        data: [processosTotal],
        backgroundColor: [
          '#5c5441'
        ],
        borderColor: [
          '#5c5441'
        ],
        borderWidth: 1,
      },
    ],
  };
  var options: any = {
    cutout: 60
  };

  return (
    <div id='container-widget-chart-process'>
      <h1>{title}</h1>
      <div className='widget-chart-process'>
        <span className='text-center-process'>
          <h3>{processosTotal}</h3>
        </span>
        <Doughnut data={data1} options={options} />
        <span className='text-center-process-desc'>
          <p>{i18n.t<string>('all')}</p>
        </span>
      </div>
      <div className='widget-chart-process'>
        <span className='text-center-process'>
          <h3>{((processosRegulares / processosTotal * 100) || 0).toFixed(0)}%</h3>
        </span>
        <Doughnut data={data2} options={options} />
        <span className='text-center-process-desc'>
          <h3>{processosRegulares}</h3>
          <p>{i18n.t<string>('regular')}</p>
        </span>
      </div>
      <div className='widget-chart-process'>
        <span className='text-center-process'>
          <h3>{((processosIrregulares / processosTotal * 100) || 0).toFixed(0)}%</h3>
        </span>
        <Doughnut data={data3} options={options} />
        <span className='text-center-process-desc'>
          <h3>{processosIrregulares}</h3>
          <p>{i18n.t<string>('irregular')}</p>
        </span>
      </div>
      <div className='widget-chart-process'>
        <span className='text-center-process'>
          <h3>{(((processosTotal - processosIrregulares - processosRegulares) / processosTotal * 100) || 0).toFixed(0)}%</h3>
        </span>
        <Doughnut data={data4} options={options} />
        <span className='text-center-process-desc'>
          <h3>{processosTotal - processosIrregulares - processosRegulares}</h3>
          <p>{i18n.t<string>('Não preenchidos')}</p>
        </span>
      </div>
    </div>
  )
}
